import { DateQueryDateTypeApiEnum } from '../../mentions/enum/date-query-date-type-api.enum';
import { RelativeTimezoneDateTypeEnum } from '../../mentions/enum/relative-timezone-date-type.enum';
import { DateRangeTypeApiEnum } from '../enums/date-range-type-api.enum';

export enum TimePeriodEnum {
    hourly = 'HOURLY',
    daily = 'DAILY',
    monthly = 'MONTHLY'
};

export interface DateRangeApiModel {
    type: DateRangeTypeApiEnum;
    relativeStartOffsetH?: number;
    relativeEndOffsetH?: number;
    absoluteRangeTimeZone?: string;
    absoluteRangeStart?: number;
    absoluteRangeEnd?: number;
    timePeriod?: TimePeriodEnum;
    dateType?: DateQueryDateTypeApiEnum;
    relativeTimezoneDateTypeEnum?: RelativeTimezoneDateTypeEnum;
    timezone?: string;
}
